// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.usfw-footer {
  color: #757575;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0%;
}
.usfw-footer a {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #757575 !important;
  text-decoration: none;
}
.usfw-footer a:focus {
  box-shadow: unset;
  outline: unset;
}`, "",{"version":3,"sources":["webpack://./src/layouts/Footer/Footer.scss"],"names":[],"mappings":"AAAA;EACI,cAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;AACJ;AAAI;EACI,aAAA;EACA,mBAAA;EACA,QAAA;EACA,yBAAA;EACA,qBAAA;AAER;AADQ;EACI,iBAAA;EACA,cAAA;AAGZ","sourcesContent":[".usfw-footer {\n    color: #757575;\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 20px;\n    letter-spacing: 0%;\n    a{\n        display: flex;\n        align-items: center;\n        gap: 8px;\n        color: #757575 !important;\n        text-decoration: none;\n        &:focus{\n            box-shadow: unset;\n            outline: unset;\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
